import { Col, Row } from 'reactstrap';
import { useFormState } from 'utils/hooks';

import Input from 'common/components/form/inputs/Input';
import NumberInput from 'common/components/form/inputs/NumberInput';
import AsyncSelector from 'common/components/selectors/AsyncSelector';
import CheckboxWithTime from 'common/components/general/CheckboxWithTime';

const LdTerm = ({ formState }) => {
  const { fields, changeField, selectField } = useFormState(formState);

  return (
    <div className="edit-ld_term">
      <Row className="no-gutters">
        <Col>
          <Input label="Name" onChange={changeField('name')} {...fields.name} />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col>
          <Input
            label="Description"
            onChange={changeField('description')}
            {...fields.description}
          />
        </Col>
      </Row>

      <Row className="no-gutter">
        <Col xs={3}>
          <NumberInput
            label="Multiplier"
            decimalScale={9}
            maxLength={12}
            onChange={changeField('multiplier')}
            {...fields.multiplier}
          />
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col xs={6} className="me-1">
          <AsyncSelector
            label="Working Start Day & Time"
            className="ld-terms-days-selector"
            onChange={e => selectField('start_day')(e)}
            getOptionValue={option => option.id}
            getOptionLabel={option => <span className="text-capitalize">{option.label}</span>}
            type="week-days"
            placeholder=""
            styled={false}
            isClearable={false}
            {...fields.start_day}
          />
        </Col>
        <Col xs={3} className="d-flex align-items-center">
          <div className="ld-terms-time-container">
            <CheckboxWithTime
              alwaysShowTime={true}
              checkboxValue={true}
              onTimeChange={selectField('start_time')}
              className="d-flex align-items-center position-relative m-0"
              time={fields.start_time.value}
            />
          </div>
        </Col>
      </Row>

      <Row className="no-gutters">
        <Col xs={6} className="me-1">
          <AsyncSelector
            label="Working End Day & Time"
            className="ld-terms-days-selector"
            onChange={e => selectField('end_day')(e)}
            getOptionValue={option => <span className="text-capitalize">{option.id}</span>}
            getOptionLabel={option => <span className="text-capitalize">{option.label}</span>}
            type="week-days"
            placeholder=""
            styled={false}
            isClearable={false}
            {...fields.end_day}
          />
        </Col>
        <Col xs={3} className="d-flex align-items-center">
          <div className="ld-terms-time-container">
            <CheckboxWithTime
              alwaysShowTime={true}
              checkboxValue={true}
              onTimeChange={selectField('end_time')}
              className="d-flex align-items-center position-relative m-0"
              time={fields.end_time.value}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default LdTerm;
